import React from 'react';
import styled from 'styled-components';

// Base styled input
const BaseInput = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

// Error message styling
const ErrorMessage = styled.span`
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
  display: block;
`;

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  validation?: 'numbers' | 'letters' | 'none';
  maxCharacters?: number;
}

export const Input: React.FC<InputProps> = ({ 
  error, 
  validation = 'none', 
  onChange,
  value,
  maxCharacters,
  onBlur,
  ...props 
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    // Validation patterns
    const numbersOnly = /^[0-9]*$/;
    const lettersOnly = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]*$/;
    
    let isValid = true;
    
    // Apply validation based on type
    switch (validation) {
      case 'numbers':
        isValid = numbersOnly.test(newValue);
        break;
      case 'letters':
        isValid = lettersOnly.test(newValue);
        break;
      default:
        isValid = true;
    }
    
    // Only update if valid or empty
    if (isValid || newValue === '') {
      onChange?.(e);
    }
  };

  return (
    <div>
      <BaseInput
        value={value}
        onChange={handleChange}
        maxLength={maxCharacters}
        onBlur={onBlur}
        {...props}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};